export default function getInnerTextDimensions(textContainerBounds,angle){

  let outerLeft = textContainerBounds.left;
  let outerBottom = textContainerBounds.bottom;
  let outerTop = textContainerBounds.top;

  if( Math.abs(angle) === 45 ){
    throw Error("Cannot compute inner dimensions from 45º angle, an additional 'pivot point' is required.");
  }



  let absTheta = 2 * Math.PI * Math.abs(angle) / 360;
  let outerHeight = textContainerBounds.height;
  let outerWidth = textContainerBounds.width;

  let c = Math.cos( absTheta );
  let s = Math.sin( absTheta );

  let det = Math.cos( 2 * absTheta ); 

  let innerHeight = (outerHeight * c - outerWidth * s) / det;
  let innerWidth = (- outerHeight * s + outerWidth * c) / det;

  //assuming pivot is bottom left

  return {
    innerHeight,
    innerWidth,
  }

}
